import { useState } from "react";

import Button from "@/design-system/button";
import { useViewportInfoContext } from "@/src/contexts";
import { browserStatics } from "@/src/shared/BrowserStatic";
import Stepper from "@Components/Stepper/Stepper";
import * as stylex from "@stylexjs/stylex";

import { type QuerySmMax, type QueryXsMax, colors } from "../../../styles/tokens.stylex";
import ModalVideo from "../../common/ModalVideo";
import { getLineInfo, stepperSteps } from "./WhatIsCashbackData";
import PlayIcon from "./icons/paly-icon.svg";

export interface IWhatIsCashback {
    youtubeVideoId?: string;
    videoButtonText?: string;
    showVideoButton?: boolean;
}

const WhatIsCashback = (props: IWhatIsCashback) => {
    const [videoModalOpen, setVideoModalOpen] = useState<boolean>(false);

    const { language } = browserStatics;
    const { isMobileOrTablet } = useViewportInfoContext();

    return (
        <div {...stylex.props(styles.wrapper)}>
            <Stepper
                lineInfo={getLineInfo(isMobileOrTablet)}
                stepList={stepperSteps(language)}
                lineColor="#c2c2c2"
            />

            {props.showVideoButton && (
                <div {...stylex.props(styles.linkPlay)}>
                    <Button
                        as="button"
                        size="M"
                        variant="transparent"
                        styleX={styles.button}
                        onClick={() => setVideoModalOpen(true)}
                    >
                        <img src={PlayIcon} alt="paly icon" />
                        <span>{props.videoButtonText}</span>
                    </Button>
                </div>
            )}

            <ModalVideo
                title="iFrame Video"
                isOpen={videoModalOpen}
                telemetryCustom={{
                    eventName: "cshbck-Video",
                    actionType: "View",
                }}
                videoId={props.youtubeVideoId || "MiRaPM3E0j4"}
                parameters={{ autoplay: 1, mute: 1 }}
                onClose={() => setVideoModalOpen(false)}
                allowFullScreen
            />
        </div>
    );
};

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    wrapper: {
        marginBlock: { default: null, [smMax]: "0" },
        marginInline: { default: null, [smMax]: "auto" },
        display: "flex",
        flexWrap: "wrap",
        position: "relative",
    },

    linkPlay: {
        backgroundColor: colors.b_Emphasis,
        color: colors.b_BrandMagenta,
        fontSize: { default: null, [xsMax]: "1.125rem" },
        fontWeight: "bold",
        textAlign: "center",
        zIndex: 1,
        paddingTop: {
            default: "30px",
            [xsMax]: 0,
        },
        width: "100%",
    },

    button: {
        gap: "10px",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        width: "100%",
    },
});

export default WhatIsCashback;
